export class MFirearmAnomalyResolution {
    anomaly: string

    description: null

    id: string

    item: string

    itemId: string

    madeAt: string

    status: string

    title: string

    userId: string

    issue: any

    ref: string

    constructor(anomaly: MFirearmAnomalyResolution) {
        this.anomaly = anomaly?.anomaly
        this.description = anomaly?.description
        this.item = anomaly?.item
        this.itemId = anomaly?.itemId
        this.madeAt = anomaly?.madeAt
        this.status = anomaly?.status
        this.title = anomaly?.title
        this.userId = anomaly?.userId
        this.issue = anomaly?.issue?.name
        this.ref = anomaly?.ref
        this.id = anomaly?.id
    }
}
